import { tokenSubTypes, tokenTypes } from '../Constants.js';
import Factory from './Factory.js';
import Util from './Util.js';
export default {
  type: 'ExpressionField.math',
  tokenize: (field, context) => {
    const toReturn = [...Util.handleAlias(field, context)];
    field.terms?.forEach(term => {
      toReturn.push(...Factory.create(term));
    });
    if (Array.isArray(field.operatorLocations)) {
      toReturn.push(...field.operatorLocations.map(opLoc => ({
        startIndex: opLoc.absolute.startIndex,
        endIndex: opLoc.absolute.endIndex,
        type: tokenTypes.OPERATOR,
        subType: tokenSubTypes.MATH
      })));
    }
    return toReturn;
  }
};